import Vue from "vue";
import VueRouter from "vue-router";
import { StorageService } from "../services/storage.service";
import g20Routes from "./modules/g20";
import dashboardRoutes from "./modules/dashboard";
import spkluRoutes from "./modules/spklu";
import monitoringRoutes from "./modules/monitoring";
import userManagementRoutes from "./modules/user_management";
import homeChargingRoutes from "./modules/homecharging";
import transaksi from "./modules/transaksi";
import availableSPKLU from "./modules/available_spklu";
import unavailableSPKLU from "./modules/unavailable_spklu";
const Layout = () => import("../views/layout/Layout");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      ...g20Routes,
      ...dashboardRoutes,
      ...spkluRoutes,
      ...monitoringRoutes,
      ...userManagementRoutes,
      ...homeChargingRoutes,
      ...transaksi,
      ...availableSPKLU,
      ...unavailableSPKLU,
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/Login_2"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// handle redudant navigation
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  const token = StorageService.getAuthdata();
  const loggedIn = !!token;

  if (!loggedIn) {
    if (to.path === "/login") {
      next();
    } else {
      next("/login");
    }
  } else if (loggedIn) {
    // limit access to page based on given auth role
    next();
    // if (to.path === '/') {
    //   next('/landing-page')
    // } else if (to.path === '/home') {
    //   next()
    // } else if (to.path === '/redirect-sso') {
    //   next()
    // } else if (to.path === '/403-forbidden') {
    //   next()
    // } else {
    //   // console.log(to.name)
    //   // console.log(MenuMixin.methods.getAccess(to.name))
    //   if (MenuMixin.methods.getAccess(to.fullPath).has_access || MenuMixin.methods.getAccess(to.fullPath).has_read) {
    //     next()
    //   } else {
    //     // next('/403-forbidden')
    //     next()
    //   }
    // }
  }
});

export default router;
